import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormDatePicker from "../../components/formFields/FormDateField";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { RootState } from "../../app/store";
import {
  getKarigarListByProcess,
  getKarigarStock,
} from "../karigar/services/karigar.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import { findAllActiveItem } from "../item/services/item.services";
import {
  createPalish,
  getPalishById,
  updatePalish,
} from "./services/palish.services";
import { findAllActiveProcess } from "../process/services/process.services";
import { clearPalishDetail } from "./palishSlice";
import PalishOrderItemArray from "./PalishOrderItemArray";
import { ErrorToast } from "../../components/toast/Toasts";
import { clearOrderDetail } from "../order/orderSlice";
import { findAllOrder } from "../order/services/order.services";
import { clearKarigarStock } from "../karigar/karigarSlice";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { FaEye } from "react-icons/fa";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const KarigarChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const karigar_id = formRenderProps.valueGetter("karigar_id");
  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };
  useEffect(() => {
    if (karigar_id) {
      fetchKarigarStock(karigar_id);
    }
  }, [karigar_id]);

  return null;
};

// interface FormChangeWatcherProps {
//   formRenderProps: FormRenderProps;
// }
// const ProcessChangeWatcher: React.FC<FormChangeWatcherProps> = ({
//   formRenderProps,
// }) => {
//   const karigar_id = formRenderProps.valueGetter("karigar_id");
//   const palish_order = formRenderProps.valueGetter("palish_order");
//   const dispatch = useAppDispatch();
//   const isFirstRun = useRef(true); // flag to skip first run
//   const fetchWeight = async (
//     previous_process_id: number,
//     order_id: number,
//     index: number
//   ) => {
//     const payload = {
//       process_id: previous_process_id,
//       order_id: order_id,
//       karigar_id: karigar_id,
//     };

//     const res = await dispatch(FetchWeight(payload));
//     if (res.meta.requestStatus === "fulfilled") {
//       formRenderProps.onChange(`palish_order.${index}.weight`, {
//         value: res.payload.Data[0].gross_weight || 0,
//       });
//     } else {
//       formRenderProps.onChange(`palish_order.${index}.weight`, {
//         value: 0,
//       });
//     }
//   };
//   useEffect(() => {
//     if (isFirstRun.current) {
//       // ⛔ skip the first run on mount (reload)
//       isFirstRun.current = false;
//       return;
//     }
//     if (palish_order && palish_order.length > 0) {
//       palish_order.forEach((item: any, index: number) => {
//         if (item.previous_process_id && item.order_id) {
//           fetchWeight(item.previous_process_id, item.order_id, index);
//         }
//       });
//     }
//   }, [
//     palish_order?.map((item: any) => item?.previous_process_id).join("-"),
//     palish_order?.map((item: any) => item?.order_id).join("-"),
//   ]);

//   return null;
// };

const CreatePalish: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const palish_guid = location?.state?.palish_guid;
  const loading = useAppSelector((state) => state.palish?.loading);
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const PalishDetail = useAppSelector(
    (state: RootState) => state.palish.PalishDetail,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterOrder = useAppSelector((state) => state.order.FilterOrder);
  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);
  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.palish));
    dispatch(findAllActiveItem());
    dispatch(findAllActiveProcess());
    return () => {
      dispatch(clearPalishDetail());
      dispatch(clearOrderDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    const payload = {
      ...FilterOrder,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
      ProcessID: PROCESS_ID.palish,
    };
    dispatch(findAllOrder(payload));
  }, [currentPage, pageLimit]);

  useEffect(() => {
    if (palish_guid) {
      dispatch(getPalishById(palish_guid));
    }
  }, [palish_guid]);
  useEffect(() => {
    setFormKey(formKey + 1);
  }, [PalishDetail]);

  const handleSubmit = async (values: any) => {
    if (values.palish_order?.length === 0) {
      ErrorToast("At least One Order is Required !");
      return false;
    }
    const formData = {
      karigar_id: values.karigar_id ? +values.karigar_id : 0,
      issue_date: values.issue_date
        ? moment(values.issue_date).format("YYYY-MM-DD")
        : "",
      approx_delivery_date: values.approx_delivery_date
        ? moment(values.approx_delivery_date).format("YYYY-MM-DD")
        : "",
      palish_order: values.palish_order
        ? values.palish_order.map((palishOrder: any) => {
            return {
              id: palishOrder.id ? palishOrder.id : 0,
              previous_process_id: palishOrder.previous_process_id
                ? +palishOrder.previous_process_id
                : null,
              order_id: palishOrder.order_id ? +palishOrder.order_id : null,
              item_id: palishOrder.item_id ? +palishOrder.item_id : null,
              item_description: palishOrder.item_description
                ? palishOrder.item_description
                : "",
              weight: palishOrder.weight ? palishOrder.weight : null,
              remarks: palishOrder.remarks ? palishOrder.remarks : "",
            };
          })
        : [],
    };
    if (palish_guid) {
      const editPayload = {
        palish_guid: palish_guid,
        palish_no: values.palish_no,
        ...formData,
      };
      try {
        const response = await dispatch(updatePalish(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/palish");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createPalish(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/palish");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };
  const handleFormClose = () => {
    navigate("/palish");
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={PalishDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <KarigarChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {palish_guid
                      ? "Update Palish Issue"
                      : "Create Palish Issue"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {palish_guid ? (
                    <Typography.h5>
                      Palish No :{" "}
                      <span style={{ color: "green" }}>
                        {PalishDetail.palish_no}
                      </span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.palish}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    name="issue_date"
                    label="Issue Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    name="approx_delivery_date"
                    label="Approx Delivery Date"
                    format={"dd/MM/yyyy"}
                    placeholder="day/month/year"
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <div className="stock-container">
                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Amount Balance
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                      >
                        {formatToIndianCurrencyWithoutSymbol(
                          karigarStock.amount || 0,
                        )}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.Amount_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>

                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Phine (gm) Stock
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                      >
                        {formatWeight(karigarStock.phine)}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.phine_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            {/* <ProcessChangeWatcher formRenderProps={formRenderProps} /> */}
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayout cols={[{ width: "100%" }]}>
                <GridLayoutItem>
                  <Typography.h4>Palish Orders</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={PalishOrderItemArray}
                    name="palish_order"
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  {isPrintAccess && palish_guid && (
                    <Button
                      type="button"
                      style={{ marginRight: 4 }}
                      fillMode={"solid"}
                      themeColor={"primary"}
                      onClick={() =>
                        window.open(`/palishissue/${palish_guid}`, "_blank")
                      }
                    >
                      <FaEye style={{ fontSize: "18" }} /> View Report
                    </Button>
                  )}
                  <ButtonWithLoading
                    label={!palish_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreatePalish;
